import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import EventCard from './EventCard';

/**
 * Displays a multi level event as a container and
 * it's group of sub events and their key details,
 * such as the title, date and time, and location.
 */
const MultiLevelEventCard = ({ oEvent }) => (
  <li className='multiLevelEventCard'>
    <Link
      className='multiLevelEvent__title t-label'
      to={`/events/${oEvent.SLUG}`}
    >
      {oEvent.TITLE}
    </Link>

    <ul className='myEvents__list'>
      {oEvent.SUB_EVENTS.map((oSubEvent) => (
        <EventCard oEvent={oSubEvent} key={oSubEvent.EVENT_ID} />
      ))}
    </ul>
  </li>
);

MultiLevelEventCard.propTypes = {
  oEvent: PropTypes.shape({
    EVENT_ID: PropTypes.string,
    TITLE: PropTypes.string,
    START_DATE_TIME: PropTypes.string,
    END_DATE_TIME: PropTypes.string,
    LOCATION: PropTypes.shape({
      NAME: PropTypes.string,
      ROOM: PropTypes.string,
      ADDRESSBLOCK: PropTypes.string,
    }),
    CONTACT: PropTypes.shape({
      NAME: PropTypes.string,
      EMAIL: PropTypes.string,
      LOOKUPID: PropTypes.string,
    }),
    SLUG: PropTypes.string,
    SUB_EVENTS: PropTypes.arrayOf(
      PropTypes.shape({
        EVENT_ID: PropTypes.string,
        TITLE: PropTypes.string,
        START_DATE_TIME: PropTypes.string,
        END_DATE_TIME: PropTypes.string,
        LOCATION: PropTypes.shape({
          NAME: PropTypes.string,
          ROOM: PropTypes.string,
          ADDRESSBLOCK: PropTypes.string,
        }),
        CONTACT: PropTypes.shape({
          NAME: PropTypes.string,
          EMAIL: PropTypes.string,
          LOOKUPID: PropTypes.string,
        }),
      })
    ).isRequired,
  }).isRequired,
};

export default MultiLevelEventCard;
